"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {"rotating":"CircularProgress_sLURy","digby-circular-progress-rotating":"CircularProgress_2Yj2A"};
tokens._getCss = function () {return `/* imported from CircularProgress.css */ @keyframes CircularProgress_2Yj2A { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } .CircularProgress_sLURy { animation: CircularProgress_2Yj2A 550ms linear infinite; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/src/svg/sync/CircularProgress_css.js"};
exports["default"] = tokens;